'use client';
import React from 'react';
import { Search, Filter } from 'lucide-react';

interface JobFiltersProps {
  search: string; setSearch: (v: string) => void;
  statusFilter: string; setStatusFilter: (v: string) => void;
  typeFilter: string; setTypeFilter: (v: string) => void;
  priorityFilter: string; setPriorityFilter: (v: string) => void;
  resultCount: number;
}

const statusOptions = ['all', 'scheduled', 'in-transit', 'on-site', 'returning', 'completed', 'invoiced'];
const typeOptions = ['all', 'Rig Setup', 'Rig Teardown', 'Equipment Haul', 'Maintenance', 'Inspection', 'Crew Transport', 'Emergency Repair', 'Water Hauling', 'Wireline Support', 'Tank Inspection'];
const priorityOptions = ['all', 'standard', 'urgent', 'critical'];

export default function JobFilters({ search, setSearch, statusFilter, setStatusFilter, typeFilter, setTypeFilter, priorityFilter, setPriorityFilter, resultCount }: JobFiltersProps) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
      <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
        {/* Search */}
        <div className="relative flex-1 min-w-0 sm:min-w-[200px]">
          <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-zinc-500" />
          <input
            type="text"
            placeholder="Search by job ID, client, city, type..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-zinc-800 border border-zinc-700 rounded-md pl-8 pr-3 py-1.5 text-sm text-zinc-300 placeholder-zinc-600 focus:outline-none focus:border-amber-500/50 transition-all"
          />
        </div>

        <div className="flex flex-wrap items-center gap-2 sm:gap-3">
          {/* Status */}
          <div className="flex items-center gap-1.5">
            <Filter size={12} className="text-zinc-500 flex-shrink-0" />
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="bg-zinc-800 border border-zinc-700 rounded-md px-2.5 py-1.5 text-xs text-zinc-300 focus:outline-none focus:border-amber-500/50 transition-all capitalize"
            >
              {statusOptions.map((s) => (
                <option key={`status-opt-${s}`} value={s} className="capitalize">{s === 'all' ? 'All Statuses' : s.replace('-', ' ')}</option>
              ))}
            </select>
          </div>

          {/* Type */}
          <select
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            className="bg-zinc-800 border border-zinc-700 rounded-md px-2.5 py-1.5 text-xs text-zinc-300 focus:outline-none focus:border-amber-500/50 transition-all"
          >
            {typeOptions.map((t) => (
              <option key={`type-opt-${t}`} value={t}>{t === 'all' ? 'All Types' : t}</option>
            ))}
          </select>

          {/* Priority */}
          <select
            value={priorityFilter}
            onChange={(e) => setPriorityFilter(e.target.value)}
            className="bg-zinc-800 border border-zinc-700 rounded-md px-2.5 py-1.5 text-xs text-zinc-300 focus:outline-none focus:border-amber-500/50 transition-all capitalize"
          >
            {priorityOptions.map((p) => (
              <option key={`priority-opt-${p}`} value={p} className="capitalize">{p === 'all' ? 'All Priorities' : p}</option>
            ))}
          </select>

          <span className="text-xs text-zinc-600 whitespace-nowrap">{resultCount} results</span>
        </div>
      </div>
    </div>
  );
}